<template>
  <div class="item-wrap">
    <div class="item">
      <slot />
      <div class="mr-3">{{ item.name }} ({{ getTypeName(item.type) }})</div>
      <b-button-group class="ml-auto">
        <b-button :variant="item.formVisible ? 'primary' : 'outline-primary'"
        :class="{ 'formVisible': item.formVisible }"
        size="sm" @click.prevent="item.formVisible = !item.formVisible">
          <i class="fa fa-cog" />
        </b-button>
      </b-button-group>
    </div>
    <div class="item-form" v-if="item.formVisible">
      <b-form-group :label="$dt('json_schema_item.name', 'Name')">
        <b-form-input v-model="item.name"/>
      </b-form-group>
      <b-form-group :label="$dt('json_schema_item.type', 'Type')">
        <b-form-select v-model="item.type">
          <option v-for="option in typeOptions" :key="option.id" :value="option.id">{{ option.name }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group :label="$dt('json_schema_item.lookup_key', 'Lookup Key')">
        <b-form-input v-model="item.lookup_key"/>
      </b-form-group>
      <b-form-group v-if="!nestableTypes.includes(item.type)" :label="$dt('json_schema_item.is_set', 'Show as dropdown')">
        <b-form-checkbox v-model="item.is_set" :value="1" :unchecked-value="0"/>
      </b-form-group>
      <b-form-group :label="$dt('json_schema_item.filter_null', 'Allow null')">
        <b-form-checkbox v-model="item.filter_null" :value="1" :unchecked-value="0"/>
      </b-form-group>
      <b-form-group :label="$dt('json_schema_item.in_filter', 'Show in filter')">
        <b-form-checkbox v-model="item.in_filter" :value="1" :unchecked-value="0"/>
      </b-form-group>
      <b-form-group :label="$dt('json_schema_item.display_in_list', 'Display in detection list results')">
        <b-form-checkbox v-model="item.display_in_list" :value="1" :unchecked-value="0"/>
      </b-form-group>
      <div class="d-flex">
        <b-button class="ml-auto" variant="danger" size="sm" @click.prevent="deleteConfirmation">
          <i class="fa fa-trash"/>
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'JsonSchemaTreeItem',
  props: {
    item: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      // obejct and object array
      nestableTypes: [11, 12],
      typeOptions: [{
        id: 0,
        name: 'String'
      },
      {
        id: 1,
        name: 'Number'
      },
      {
        id: 2,
        name: 'Boolean'
      },
      {
        id: 3,
        name: 'Decimal'
      },
      {
        id: 5,
        name: 'Timestamp'
      },
      {
        id: 6,
        name: 'String Array'
      },
      {
        id: 7,
        name: 'Number Array'
      },
      {
        id: 8,
        name: 'Boolean Array'
      },
      {
        id: 9,
        name: 'Decimal Array'
      },
      {
        id: 10,
        name: 'Timestamp Array'
      },
      {
        id: 11,
        name: 'Object'
      },
      {
        id: 12,
        name: 'Object Array'
      }],
    };
  },
  watch: {
    item: {
      handler() {
        this.$emit('input', this.item);
      },
      deep: true
    }
  },
  mounted() {
    // generate uuid for new items
    if (!this.item.uuid) {
      this.item.uuid = uuidv4();
    }
  },
  methods: {
    deleteConfirmation() {
      this.$bvModal.msgBoxConfirm(this.$dt('json_schema_item.delete_confirmation', 'Are you sure you want to delete this item?'), {
        title: this.$dt('json_schema_item.delete', 'Delete'),
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$dt('global.delete', 'Delete'),
        cancelTitle: this.$dt('global.cancel', 'Cancel'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then((value) => {
        if (value) {
          this.$emit('delete');
        }
      });
    },
    getTypeName(type) {
      return this.typeOptions.find((item) => item.id === type)?.name;
    }
  }
};
</script>
<style lang="scss">
.item {
  padding: 1rem;
  background-color: #fefefe;
  display: flex;
  align-items: center;
}

.item-wrap {
  border: 1px solid #a2a5a7;
}

.item-form {
  padding: 1rem;
  border-top: 1px solid #a2a5a7;
}
</style>
